import { useContext, useEffect, useState, useRef } from 'react'
import { useForm } from 'react-hook-form'
import Modal from 'react-modal'
import axios from 'axios'

import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';

import { projectContext, loadingContext, unfolder, urlValue,  useTranslate } from '../lib'
import SideBar from '../components/SideBar'

import { customModal } from '../styles/customModal'
import '../styles/report.scss'
import '../styles/general.scss'
import TitleBar from "../components/TitleBar";
import { useParams } from 'react-router-dom'
export default function Report(props) {
  const { onClose } = props
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [clients, setClients] = useState([])
  const [screen, setScreen] = useState(1)
  const params = useParams();
  const [isModalOpen, setIsModalOpen] = useState({
    delete: false,
    new: false,
    edit: false,
  })
  const [refresh, setRefresh] = useState(false)
  const [selectedClient, setSelectedClient] = useState()
  const ref = useRef(null)
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useContext(loadingContext)
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm()
  const { t } = useTranslate();


  const firstReport = `https://datastudio.google.com/embed/reporting/26350efd-c6b1-4056-a038-c2fc4791d685/page/p_9po833n00c?params=%7B%22df52%22:%22include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%${props?.project.id}%22%7D`
  const secondReport = `https://datastudio.google.com/embed/reporting/762fe65a-7390-4cca-af72-85fcf7453e37/page/p_9po833n00c?params=%7B%22df52%22:%22include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%${props?.project.id}%22%7D`
  return (
    <>

      <div className="container-info d-flex flex-row flex-wrap align-items-center w-100 justify-space-between">
        <div className="title d-flex flex-row justify-center align-items-center">

          <div>
            <h2>{t('reports.report')}</h2>
          </div>
          <div className="p-1 separator">-</div>
          <div>
            <h2>{props?.project.name}</h2>
          </div>

        </div>

        <div className='w-full flex flex-col   self-center items-center content-center' >
          {/* <iframe src="https://datastudio.google.com/reporting/53dfbc18-5b2d-486c-a36f-f461e3a880d7/page/kK78C?params=%7B%22df46%22:%22include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%2580120%22%7D" height="400px" width="600px"></iframe> */}
          <div className="header-rep flex flex-row items-center">
            <button type='button' onClick={() => { setScreen(1) }} className={`${screen === 1 ? 'active-rep' : ''} py-4 px-8 btn-tab-r`}   >{t('common.users')}</button>
            <button type='button' onClick={() => { setScreen(2) }} className={`${screen === 2 ? 'active-rep' : ''} py-4 px-8 btn-tab-r`} >{t('menu.feedback')}</button>
          </div>

          <div className='w-full flex flex-row items-center  justify-center ' >
            {screen === 1 ? <div id={`${'id-cont-rep-1'}`} className="mr-3 cont-rep ">
              <iframe height="700" style={{ borderRadius: 12 }} width="1024" src={firstReport} frameborder="0" ></iframe>
            </div> : null}
            {screen === 2 ? <div id={`${'id-cont-rep-2'}`} className=" cont-rep  ">
              <iframe height="700" width="1024" style={{ borderRadius: 12 }} src={secondReport} frameborder="0"></iframe>
            </div> : null}
          </div>


        </div>
        <div className="btn-close-report" style={{float: "right"}} onClick={onClose}>
            {t('common.close')}
        </div>
      </div>


    </>
  )
}
